export const tertiary = {
    100: "#FFF8F7",
    98: "#FFEDEB",
    95: "#FFDAD6",
    90: "#FFB3AC",
    80: "#FF8980",
    70: "#FF544D",
    60: "#E42B2E",
    50: "#BF0318",
    40: "#93000F",
    30: "#680008",
    20: "#FFFFFF",
    10: "#410003",
    0: "#000000",
};
export default tertiary;
